import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { getUser, LoyaltyApi } from "@jti/rest-api";
import { useLoyalty } from "../../../../hooks/useLoyalty";
import { useHeaderContext } from "../../context";
import styles from "./PointsDisplay.module.scss";
export const PointsDisplay = ({ loyaltyCurrency }) => {
    const { loyaltyPoints, isLoyaltyActive, setLoyaltyData } = useHeaderContext();
    const isLoyaltyVerifiedSuccessfully = useLoyalty();
    useEffect(() => {
        const user = getUser();
        const getLoyaltyData = async () => {
            try {
                const [tier, points] = await Promise.all([
                    LoyaltyApi.init().getUserTier(user.uuid, user.ciam_token),
                    LoyaltyApi.init().getPoints(user.uuid, user.ciam_token),
                ]);
                setLoyaltyData({
                    userTier: tier.name,
                    points: points.points,
                    isActive: isLoyaltyVerifiedSuccessfully,
                });
            }
            catch (error) {
                console.error("Error fetching loyalty data:", error);
            }
        };
        if (isLoyaltyVerifiedSuccessfully && user.uuid && user.ciam_token) {
            getLoyaltyData();
        }
        else {
            setLoyaltyData((prevState) => ({
                ...prevState,
                isActive: isLoyaltyVerifiedSuccessfully,
            }));
        }
    }, [isLoyaltyVerifiedSuccessfully, setLoyaltyData]);
    if (!isLoyaltyActive || loyaltyPoints === null) {
        return null;
    }
    return (_jsxs("div", { className: styles.pointsDisplay, children: [_jsx("span", { className: styles.points, children: loyaltyPoints }), _jsx("span", { className: styles.currency, children: loyaltyCurrency })] }));
};
//# sourceMappingURL=PointsDisplay.js.map